import { render, staticRenderFns } from "./ManagerPlateComponent.vue?vue&type=template&id=859a572e"
import script from "./ManagerPlateComponent.vue?vue&type=script&lang=js"
export * from "./ManagerPlateComponent.vue?vue&type=script&lang=js"
import style0 from "./ManagerPlateComponent.vue?vue&type=style&index=0&id=859a572e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports